module.exports = __webpack_public_path__ + "app/docrepo-invoice/docrepo-invoice-list-z-lU6zng.html";